module.exports = require("@mui/material/Skeleton");